<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="mb-2 d-flex align-items-center justify-content-between"
        >
          <h4 class="mb-0 font-size-18">{{ $t(title) }}</h4>

          <div class="page-title-right">
            <div class="col-md text-right">
                <router-link
                  :to="{ path: '/roles/create' }"
                  class="btn btn-primary"
                >
                  <b>Nouveau</b>
                </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="q-pa-md">
          <div v-if="isLoading">
            <b-skeleton-table
              :rows="6"
              :columns="2"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </div>
          <table
            class="table table-hover mt-2"
            v-else-if="roles.length > 0"
          >
            <thead class="thead-light">
              <tr>
                <th class="text-left">{{ $t("pages.roles.name") }}</th>
                <th class="text-left">Description</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="role in pageOfItems" :key="role.id">
                <td>{{ role.name }}</td>
                <td>{{ role.slug }}</td>
                <td class="text-center">
                  <b-dropdown
                    class="card-drop"
                    variant="white"
                    right
                    toggle-class="p-0"
                  >
                    <template v-slot:button-content>
                      <i class="mdi mdi-dots-horizontal font-size-18"></i>
                    </template>
                    <b-dropdown-item
                      @click="
                        $router.push({ path: `/roles/edit/${role.id}` })
                      "
                    >
                      {{ $t("pages.documentType.edit") }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="onDelete(role)"
                    >
                      {{ $t("pages.documentType.delete") }}
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center" v-else>
            <h3 class="text-center">
              {{ $t('pages.roles.empty.title') }}
            </h3>
            <p class="mt-2">
              {{ $t('pages.roles.empty.text') }}
            </p>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="text-center">
              <jw-pagination
                :pageSize="pageSize"
                :items="roles"
                @changePage="onChangePage"
                :labels="labels"
                class="text-center"
              ></jw-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>


<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapActions, mapState } from "vuex";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Roles",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      isLoading: false,
      title: "pages.roles.roles",
      items: [
        {
          text: "pages.roles.Paramètres",
        },
        {
          text: "pages.roles.list",
        },
      ],

      labels: {
        first: "<<",
        last: ">>",
        next: ">",
        previous: "<",
      },

      bool: false,
      pageOfItems: [],
      pageSize: 5,
    };
  },
  methods: {
    ...mapActions(["getRoles", "deleteRole"]),

    edit(roleId) {
      this.$router.push({ path: `/roles/edit/${roleId}` });
    },
    onDelete(role) {
      console.log(role);
      if (this.$can("delete", "roles")) {
        this.$toasted.clear();
        this.$swal({
          text: this.$t("pages.roles.actions.swal") + ` ${role.name} ?`,
          confirmButtonColor: "#d33",
          confirmButtonText: this.$t("pages.users.delete"),
        }).then((result) => {
          if (result.value) {
            this.deleteRole(role.id).then((response) => {
              if (response) {
                this.isDeleting = true;
                this.$swal(
                  this.$t("pages.roles.actions.confirm"),
                  this.$t("pages.roles.actions.deleted"),
                  "success"
                ).then(() => { this.isLoading = false })
              } else {
                this.isDeleting = false;
              }
            })
            .catch(() => {
              this.$toasted.error(this.$t("pages.roles.actions.impossible"));
            });
          }
        });
      } else {
        this.$toasted.error(this.$t('pages.unauthorized.forbidden_1'));
      }
    },

    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
      console.log(" items:" + this.pageOfItems);
    },
  },
  computed: {
    ...mapState({
      roles: (state) => state.roles.roles,
    }),
  },

  created() {
    this.isLoading = true;
    setTimeout(() => {
      this.$toasted.clear();
    }, 2000);

    if (this.$can("list", "roles")) {
      this.getRoles().then((loaded) => {
        if (loaded) {
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.table-row {
  cursor: pointer;
  .card-drop {
    visibility: hidden;
  }
  &:hover {
    & .card-drop {
      visibility: visible;
      align-self: center;
    }
  }
}
</style>


